import { defineComponent as _defineComponent } from 'vue'
import { onMounted, onUnmounted, ref } from "vue";
import router from "@/router";
import { useI18n } from 'vue-i18n'
import { Toast } from "vant";
import { logOffCustomer } from "@/api/php/user";
import { nativeToLogin } from "@/uitls/native";
import Storage from "@/uitls/Storage";
import { usePiniaState } from "@/store/userPinia";
import { serverConfigPiniaState } from "@/store/serverConfig";
import { storeToRefs } from "pinia";

export default /*#__PURE__*/_defineComponent({
  name: 'DeleteAcc',
  setup(__props, { expose }) {
  expose();



const piniaStore = usePiniaState();
const { exituser } = piniaStore;
const configStore = serverConfigPiniaState();
const { getConfig } = configStore;
const { user } = storeToRefs(piniaStore);

const { t } = useI18n()
const showAnn = ref(false)
const userId = ref("");


onMounted(() => {

});

onUnmounted(() => {

});

const onClickLeft = () => {
    router.back();
}

const delAccount = () => {
    showAnn.value = true;
}

const onConfirm = async () => {
    showAnn.value = false;
    let fid = userId.value;
    if (!user.value) {
        nativeToLogin(router);
        return;
    }
    if (!fid) {
        Toast.success(t('me.delaccontent7'));
        return;
    }


    let token = Storage.get("token");
    console.log("customerID", user.value.fid);
    console.log("token", token);
    console.log("fid", fid);

    if (Number(fid) != user.value.fid) {
        Toast.success(t('me.delaccontent8'));
        return;
    }

    let res: any = await logOffCustomer({ customer_id: fid, token: token });
    if (res.code == 200) {
        exituser();

        const toast = Toast.loading({
            duration: 0,
            forbidClick: true,
            message: `${t('me.tccg')}，3 ${t('me.mhtcsy')}`,
        });

        let second = 3;
        const timer = setInterval(() => {
            second--;
            if (second) {
                toast.message = `${t('me.tccg')}，${second} ${t('me.mhtcsy')}`;
            } else {
                clearInterval(timer);
                Toast.clear();
                getConfig(false);
                nativeToLogin(router);
            }
        }, 1000);

    }
};

const onCancel = () => {
    showAnn.value = false;
};


const __returned__ = { piniaStore, exituser, configStore, getConfig, user, t, showAnn, userId, onClickLeft, delAccount, onConfirm, onCancel }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})